import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('sow_user');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (authResponse) => {
    const { token, username, role, membershipNumber } = authResponse;
    localStorage.setItem('sow_token', token);
    const userData = { username, role, membershipNumber };
    localStorage.setItem('sow_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('sow_token');
    localStorage.removeItem('sow_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
